import { adminHttpClient } from '../commons/adminHttpClient'

const completeEnrollEmployeesTask = () => adminHttpClient.put('/Companies/CompleteEnrollEmployeesTask', {})

export default completeEnrollEmployeesTask
